"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var CheckboxParts = _interopRequireWildcard(require("./CheckboxParts"));
var _excluded = ["name", "value", "children", "id", "label", "iconName", "automationHook", "isHighlighted"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /**
   * Name for the radio input field
   */
  name: _propTypes["default"].string,
  /**
   * Value for the radio input field
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  /**
   * Id for the radio input field
   */
  id: _propTypes["default"].string,
  /**
   * Children to be rendered inside the label
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /**
   * Label for button
   */
  label: _propTypes["default"].string,
  /**
   * A valid icon name as defined in "Icons/components".
   */
  iconName: _propTypes["default"].string,
  /**
   * Specify a valid css value for opacity of the button when it is disabled. Fallback 0.5
   */
  disabledOpacity: _propTypes["default"].string,
  /**
   * Used for automation testing
   * Will append the `check` suffix
   */
  automationHook: _propTypes["default"].string,
  /** Specifies if the current field is highlighted */
  isHighlighted: _propTypes["default"].bool
};
var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    value = _ref.value,
    children = _ref.children,
    id = _ref.id,
    label = _ref.label,
    iconName = _ref.iconName,
    automationHook = _ref.automationHook,
    isHighlighted = _ref.isHighlighted,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(CheckboxParts.Wrapper, (0, _automationHooks.hook)(automationHook, "checkbox"), /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox",
    id: id || "".concat(name, "_").concat(value),
    value: value,
    name: name
  }, rest)), /*#__PURE__*/_react["default"].createElement(CheckboxParts.MarkAndLabel, {
    iconName: iconName,
    htmlFor: id || "".concat(name, "_").concat(value),
    isHighlighted: isHighlighted
  }, label || children));
};
Checkbox.propTypes = propTypes;
var _default = Checkbox;
exports["default"] = _default;